import { render, staticRenderFns } from "./merchantsCollection.vue?vue&type=template&id=c97eb17e&"
import script from "./merchantsCollection.vue?vue&type=script&lang=js&"
export * from "./merchantsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports